import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';
import { OPACITY_33, OPACITY_88 } from 'constants/opacity';
import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';
import { getPageBackgroundColor } from 'styles/helpers/getThemeStyles';

const StyledHelpIcon = styled(HelpIcon)(({ theme }) => {
  return {
    fill: calculateRgbaWithAlpha(
      theme.palette.sectionNav.link.main,
      OPACITY_33
    ),
    fontSize: 16
  };
});

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, maxWidth }) => ({
  '& .MuiTooltip-tooltipArrow': {
    backgroundColor: calculateRgbaWithAlpha(
      theme.palette.sectionNav.link.main,
      OPACITY_88
    ),
    maxWidth: maxWidth ?? 200,
    position: 'relative',
    color: getPageBackgroundColor(theme)
  },
  '& .MuiTooltip-arrow': {
    color: calculateRgbaWithAlpha(
      theme.palette.sectionNav.link.main,
      OPACITY_88
    )
  }
}));

function HelpToolTip({ children, ...rest }) {
  return (
    <StyledTooltip
      title={<Box data-testid="help-tooltip-container">{children}</Box>}
      arrow
      enterTouchDelay={0}
      {...rest}
    >
      <IconButton size="small">
        <StyledHelpIcon fontSize="small" />
      </IconButton>
    </StyledTooltip>
  );
}

HelpToolTip.propTypes = {
  children: PropTypes.node
};

export default HelpToolTip;
